import { Controller } from '@hotwired/stimulus'

export default class FormBrandingController extends Controller<HTMLFormElement> {
  static targets = ['uploadPanel', 'accountPanel', 'nonePanel', 'input', 'placeholder', 'image', 'fileActions', 'chooseButton', 'removeField', 'save']
  static values = { mode: String }

  declare readonly uploadPanelTarget: HTMLElement
  declare readonly accountPanelTarget: HTMLElement
  declare readonly nonePanelTarget: HTMLElement
  declare readonly inputTarget: HTMLInputElement
  declare readonly placeholderTarget: HTMLElement
  declare readonly imageTarget: HTMLImageElement
  declare readonly fileActionsTarget: HTMLElement
  declare readonly chooseButtonTarget: HTMLButtonElement
  declare readonly removeFieldTarget: HTMLInputElement
  declare readonly saveTarget: HTMLButtonElement
  declare readonly hasSaveTarget: boolean
  declare readonly modeValue: string

  private currentMode = ''
  private hasOwnLogo = false
  private ownLogoSrc = ''

  connect (): void {
    this.currentMode = this.modeValue
    this.hasOwnLogo = !this.imageTarget.classList.contains('d-none')
    this.ownLogoSrc = this.imageTarget.getAttribute('src') ?? ''
    this.refresh()
  }

  onModeChange (event: CustomEvent<{ value: string }>): void {
    this.currentMode = event.detail.value

    if (this.removeFieldTarget.checked) {
      this.restoreOwnLogo()
    }

    this.uploadPanelTarget.classList.toggle('d-none', this.currentMode !== 'upload')
    this.accountPanelTarget.classList.toggle('d-none', this.currentMode !== 'use_account_logo')
    this.nonePanelTarget.classList.toggle('d-none', this.currentMode !== 'none')

    this.refresh()
  }

  private restoreOwnLogo (): void {
    this.removeFieldTarget.checked = false

    if (this.hasOwnLogo) {
      this.imageTarget.src = this.ownLogoSrc
      this.imageTarget.classList.remove('d-none')
      this.placeholderTarget.classList.add('d-none')
      this.fileActionsTarget.classList.remove('d-none')
      this.chooseButtonTarget.classList.add('d-none')
    }
  }

  chooseFile (): void {
    this.inputTarget.click()
  }

  preview (): void {
    const file = this.inputTarget.files?.[0]

    if (!file) {
      return
    }

    const reader = new FileReader()

    reader.onload = () => {
      if (typeof reader.result === 'string') {
        this.imageTarget.src = reader.result
      }

      this.placeholderTarget.classList.add('d-none')
      this.imageTarget.classList.remove('d-none')
      this.fileActionsTarget.classList.remove('d-none')
      this.chooseButtonTarget.classList.add('d-none')
      this.removeFieldTarget.checked = false

      this.refresh()
    }

    reader.readAsDataURL(file)
  }

  removeLogo (): void {
    this.inputTarget.value = ''
    this.imageTarget.removeAttribute('src')
    this.imageTarget.classList.add('d-none')
    this.placeholderTarget.classList.remove('d-none')
    this.fileActionsTarget.classList.add('d-none')
    this.chooseButtonTarget.classList.remove('d-none')
    this.removeFieldTarget.checked = true

    this.refresh()
  }

  refresh (): void {
    if (!this.hasSaveTarget) {
      return
    }

    const modeChanged = this.currentMode !== this.modeValue
    const fileChosen = (this.inputTarget.files?.length ?? 0) > 0
    const removing = this.removeFieldTarget.checked

    this.saveTarget.disabled = !(modeChanged || fileChosen || removing)
  }
}
